import * as yup from "yup";

export const PADAgreenmentValidationSchema = yup.object().shape({
	bankName: yup.string().required("Name is required"),
	branchAddress: yup.string().required("Branch Address is required"),

	bankManagerName: yup.string().required("Name is required"),
	// bankManagerEmail: yup.string().required("Email is required"),
	bankManagerPhone: yup.string().required("Phone No. is required"),

	accountHolderName: yup.string().required("Name is required"),
	accountHolderEmail: yup
		.string()
		.trim()
		.required("Email is required")
		.email("Must be a valid email address")
		//   .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address"),
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		}),
	accountHolderPhone: yup.string().required("Phone No. is required"),

	// bankManagerEmail: yup.string().email("Must be a valid email address").nullable(),
	bankManagerEmail: yup
		.string()
		.trim()
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.nullable(),

	// jointAccountHolderName: yup.string().required("Name is required"),
	jointAccountHolderEmail: yup
		.string()
		.trim()
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.nullable(),
	// jointAccountHolderPhone: yup.string().required("Phone No. is required"),
});
